<mbs-modal
  #modal
  [isCustomModal]="true"
  [showFooter]="true"
  [title]="'shared:prePostActionsVerification.title' | i18next"
  [titleTextOverflow]="true">
  <div modal-body>
    <p class="mb-2">{{ 'shared:prePostActionsVerification.message' | i18next }}</p>
    <p class="mb-2">{{ 'shared:prePostActionsVerification.chooseOption' | i18next }}</p>
    <ol class="mb-0 pl-4">
      <li>{{ 'shared:prePostActionsVerification.optionRequestVerification' | i18next }}</li>
      <li>{{ 'shared:prePostActionsVerification.optionDisable' | i18next }}</li>
      <li>{{ 'shared:prePostActionsVerification.optionCancel' | i18next }}</li>
    </ol>
  </div>
  <ng-container modalFooter>
    <mbs-button
      type="primary"
      [loading]="loading"
      (click)="requestVerification()"
      >{{ 'shared:prePostActionsVerification.requestVerification' | i18next }}
    </mbs-button>
    <mbs-button
      type="secondary"
      [disabled]="loading"
      (click)="modal.save(answer.DisablePrePostActions)"
      >{{ 'shared:prePostActionsVerification.disablePrePostActions' | i18next }}
    </mbs-button>
    <mbs-button
      data-dismiss="modal"
      type="secondary"
      [disabled]="loading"
      (click)="modal.close()"
      >{{ 'shared:buttons.cancel' | i18next: { format: 'title' } }}
    </mbs-button>
  </ng-container>
</mbs-modal>
